<template>
  <div :style="style" class="portLineTop">
    <div
      v-for="item in ports"
      :key="item.Sid"
      :class="current!=item.Sid? 'hportDetail hPortPosition':'hportDetail hPortPosition portCheck'"
      :style="styleDetail"
      @click="$emit('portClick',item.Sid)"
    >
      
      <div  v-if="item.Status == 0" class="ksflexcol">
        空闲
      </div>
      <div v-else class="ksflexcol carAnimateIn" style="height:100%">
        <div style="flex: 1;padding:0 20% 5px 20%;width:100%">
        <div style="text-align: center">{{ item.Plate || "无车牌" }}</div>
          <img
            :src="coverImg"
            style="width: 100%;height:auto;max-height:100%"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.hportDetail {
  display: inline-block;
  cursor: pointer;
}
.carRevertBottom{
    /* transform: rotateZ(90deg); */
}
</style>
<script>
export default {
  props: ["hheight", "ports","width","current"],
  data() {
    return {
      style: {
        height: "0px",
        width: "auto",
        "white-space": "nowrap",
      },
      styleDetail: {
        height: "0px",
        width: "0px",
      },
      coverImg: require("@/assets/img/ic_car_h.png"),
    };
  },
  watch: {
    hheight() {
      this.init();
    },
    width(){
        this.init();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.style.height = this.hheight + "px";
      this.styleDetail.height = this.hheight + "px";
      this.styleDetail.width = this.hheight * 2.5 + "px";
      this.style.width=this.width+"px";
    },
  },
};
</script>